<template>
  <div>
    <h2>All Clients</h2>

    <pending-consults></pending-consults>

    <div class="row">
      <form action="" @submit.prevent="onFilter">
        <div class="input-group col-sm-3 col-sm-offset-9">
          <div class="input-group-btn" v-if='nameFilter'>
            <a class="btn btn-default" href="#" @click.prevent="runClearFilter">
              <span class="glyphicon glyphicon-remove"></span>
            </a>
          </div>
          <input type="text" v-model="nameFilter" class="form-control" placeholder="Search...">
          <div class="input-group-btn">
            <button class="btn btn-primary" type='submit'>
              <span class="glyphicon glyphicon-search"></span>
            </button>
          </div>
        </div>
      </form>
    </div>


    <div class="row text-left">
      <table class="table table-striped">
        <thead>
          <tr>
            <th width="25%">Name</th>
            <th width="10%">Client ID</th>
            <th width="10%">Code</th>
            <th width="10%">Last Completed Consult</th>
            <th width="10%">Next Consult</th>
            <th width="10%">Dashboard</th>
          </tr>
        </thead>


        <tbody>

          <tr class="text-center" v-if="clients.length == 0">
            <td colspan="6">
              <img style="margin: 30px 50%"  src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
            </td>
          </tr>

          <template v-else>
            <tr v-for="client in filteredClients" :key="client.id" :class="getTrClass(client.vet_order)">
              <td class="text-left">{{ client.display_name }}</td>
              <td class="text-center">{{ client.id }}</td>

              <td>{{ client.client_code }}</td>

              <td>
                <router-link
                    :to="lastCompletedConsultParams(client)"
                    class="btn btn-default"
                    v-if="client.last_completed_consult"
                    :disabled="!canViewLastCompletedConsult(client.id)"
                    :event="canViewLastCompletedConsult(client.id) ? 'click' : ''">

                  {{client.last_completed_consult.consult_type}} - {{client.last_completed_consult.season_start_year}}
                </router-link>
                <span class="btn btn-default disabled" v-else>
                  No completed consults yet.
                </span>
              </td>

              <td>
                <router-link
                    :to="nextConsultParams(client)"
                    class="btn btn-default"
                    :disabled="!user.client_ids.includes(client.id) && !user.is_superuser"
                    v-if="client.last_completed_consult"
                    :event="user.client_ids.includes(client.id) || user.is_superuser ? 'click' : ''">
                  {{ nextConsultText(client) }}
                </router-link>
                <span class="btn btn-default disabled" v-else>
                  No completed consults yet.
                </span>
              </td>
              <td>
                <router-link :to="{name: 'client_dashboard', params: {'client_id': client.id}}" class="btn btn-default">
                  Open
                </router-link>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <div class="col-md-12" v-if="filteredClients.length > 0 && totalPages > 1">
        <pagination v-model="currentPage"
                      :page-count="totalPages"
                      :classes="bootstrapPaginationClasses">
        </pagination>
      </div>
    </div>
  </div>
</template>

<script>

import {mapState, mapActions} from 'vuex'
import  PendingConsults  from '../components/PendingConsults'
import { get_dairy_season_start_year, unslugify } from '@/_helpers/utils'
import Pagination from '@/components/Pagination'
import { authHeader, indexedDB } from '../_helpers';
import { BASE_API_URL, consultFormService } from '../_services';
import axios from 'axios';

export default {
  components: {
    PendingConsults,
    Pagination,
  },
  data () {
    return {
      nameFilter: '',
      currentPage: 1,
      pageSize: 30,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      },
    }
  },
  mounted() {
    this.nameFilter = this.$store.state.client.filter
    if (this.clients.length == 0)
    {
      this.getClients()
    }
    this.backupPendingConsults()
  },
  methods: {
    ...mapActions('client', ['getClients', 'clearFilter']),
    runClearFilter: function()
    {
      this.nameFilter = ''
      this.clearFilter()
    },
    backupPendingConsults()
    {
			let self = this;
      let lastSync = localStorage.getItem("ezyvet-last-autobackup");
      if (!lastSync || this.$moment(lastSync).isBefore(this.$moment().subtract(1, 'minutes'))) {
        let ctypes = [
          "winter-consult",
          "spring-consult",
          "spring-review",
          "dry-cow-consult",
          "general-farm-consult"
        ];
        for (let ctype of ctypes) {
          indexedDB.getAll(ctype).then(function(consults) {
            for (let consult of consults) {
              self.backup(consult);
            }
          });
        }
        localStorage.setItem("ezyvet-last-autobackup", this.$moment())
      }
    },
    backup(consult)
    {
      consultFormService.consultBackup(consult, consult.client);

      if (!consult.client) {
				console.log(consult)
        return
      }
      axios({
        method: "post",
        url: `${BASE_API_URL}/clients/${consult.client}/indexeddb/backup`,
        headers: authHeader(),
        data: consult
      })
        .then(console.log)
        .catch(console.log);
    },
    canViewLastCompletedConsult(clientId)
    {
      return (this.user.client_ids.includes(clientId) || this.user.is_superuser || this.user.is_farm_staff)
    },
    lastCompletedConsultParams: function (client) {
      if (! client.last_completed_consult) return '#'

      let season;

      if (client.last_completed_consult.consult_type_slug != 'general_farm_consult') {
        season = client.last_completed_consult.season_start_year
      } else {
        season =  client.last_completed_consult.consult_opened_date
      }

      return {
        name: client.last_completed_consult.consult_type_slug,
        params: {
          client_id: client.id,
          season: season,
          history: 'history'
        }
      }
    },
    getTrClass: function(vetOrder) {
      return ['default', 'info', 'active', 'warning'][vetOrder]
    },
    nextConsultText: function(client)
    {
      // TODO: merge nextConsultText and nextConsultParams to prevent duplication
      let nextConsultType = this._getNextConsultType(client)
      let consultText = unslugify(nextConsultType)

      if (nextConsultType == 'general_farm_consult') {
        if (client.last_gf_consult && client.last_gf_consult.state == 'initial') {
          return `${consultText} - Reopen current consult`
        }
        return `${consultText} - Start a new consult`
      }

      return `${consultText} - ${this._getNextConsultSeason(client, nextConsultType)}`
    },
    _getNextConsultSeason: function (client, nextConsultType) {
      let consultSeason = get_dairy_season_start_year({forWinterConsult: (nextConsultType == 'winter_consult')})

      if (client.last_completed_consult) {
        let last_consult_slug = client.last_completed_consult.consult_type_slug
        let last_consult_year = client.last_completed_consult.season_start_year

        // if (nextConsultType == 'winter_consult' && last_consult_slug == 'dry_cow_consult') {
        //   return consultSeason + 1
        // } else
        if (last_consult_slug == 'general_farm_consult') {
          return last_consult_year + 1
        }
      }
      return consultSeason
    },
    _getNextConsultType: function (client)
    {
      let nextConsultType = null;
      if (!client.last_completed_consult) {
        return ''
      } else {
        switch (client.last_completed_consult.consult_type_slug) {
          case 'general_farm_consult':
            nextConsultType = 'general_farm_consult'
            break;
          case 'winter_consult':
            nextConsultType = 'spring_consult'
            break;
          case 'spring_consult':
            nextConsultType = 'dry_cow_consult'
            break;
          case 'dry_cow_consult':
            nextConsultType = 'winter_consult'
            break;
          default:
        }
      }
      return nextConsultType
    },
    nextConsultParams: function (client)
    {
      let nextConsultType = this._getNextConsultType(client)
      let season = get_dairy_season_start_year({forWinterConsult: (nextConsultType == 'winter_consult')})

      // if (nextConsultType == 'winter_consult' && client.last_completed_consult  && client.last_completed_consult.consult_type_slug == 'dry_cow_consult') {
      //   season += 1
      // } else
      if (nextConsultType == 'general_farm_consult') {
        if (client.last_gf_consult && client.last_gf_consult.state == 'initial') {
          season = client.last_gf_consult.consult_opened_date
        } else {
          season = this.$moment().format('YYYY-MM-DD')
        }
      }
      return {
        name: nextConsultType,
        params: {
          client_id: client.id,
          season: season
        }
      }
    },
    onFilter: function(){
      this.currentPage = 1
      if (this.nameFilter) {
        this.getClients({'search': this.nameFilter, 'search_type': 'all'})
      } else {
        this.getClients()
      }
    },
  },
  computed: {
    ...mapState('client', ['clients']),
    ...mapState('account', ['user']),
    totalPages: function ()
    {
      return Math.ceil(this.clients.length / this.pageSize)
    },
    filteredClients: function() {
      let pageIndex = (this.currentPage - 1) * this.pageSize
      return (this.clients.length > 0)
      ? this.clients.slice(pageIndex, pageIndex + this.pageSize)
      : []
    }
  },
};
</script>
